import { observer } from "mobx-react-lite"
import styles from "./styles.module.scss"
import { useMutation } from "@tanstack/react-query"
import { useMemo } from "react"
import { getPublicApiKey } from "../../../../../../../services/firebase-functions/userSettings.ts"

class IntegrationDetailsStore {
  apiKey: string

  setApiKey(apiKey: string) {
    this.apiKey = apiKey
  }
}

export const IntegrationDetails = observer(() => {
  const store = useMemo(() => new IntegrationDetailsStore(), [])

  const { mutate: revealApiKey, isPending } = useMutation({
    mutationFn: async () => {
      const apiKey = await getPublicApiKey()

      store.setApiKey(apiKey)
    },
  })

  return (
    <div className={styles.integrationDetailsContainer}>
      <div className={styles.sectionInfo}>
        <p className={styles.sectionTitle}>Integration</p>
        <p className={styles.sectionDescription}>Export data from Cruisen using our API</p>
      </div>
      <div className={styles.integrationDetails}>
        <div className={styles.apiKey}>{store.apiKey ? store.apiKey : "•••••••••"}</div>
        <button
          onClick={() => revealApiKey()}
          disabled={isPending}
          className={styles.revealApiKeyButton}
        >
          {isPending ? "Loading..." : "Reveal API key"}
        </button>
      </div>
    </div>
  )
})
